/**
 * @components excellent teacher loop
 * @author 陈恩浩
 */

import React, { Component } from 'react'
import Swiper from 'swiper'

import 'src/static/swiper/swiper.css'
import './index.scss'
import Info from './data';

class Teachers extends Component {
  constructor(props) {
    super(props)
    this.state = {
      status: false,
      selectTeacher: {}
    }
  }

  handleClickTeacher = (selectTeacher) => {
    this.setState({ status: true, selectTeacher })
  }

  handleClose = () => {
    this.setState({ status: false })
  }

  componentDidMount() {
    new Swiper('.swiper-container-teacher', {
      watchSlidesProgress: true,
      slidesPerView: 'auto',
      centeredSlides: true,
      loop: true,
      loopedSlides: 5,
      autoplay: true,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      pagination: {
        el: '.swiper-pagination',
        //clickable :true,
      },
      on: {
        progress: function (progress) {
          for (let i = 0; i < this.slides.length; i++) {
            let slide = this.slides.eq(i), slideProgress = this.slides[i].progress, modify = 1;
            if (Math.abs(slideProgress) > 1) {
              modify = (Math.abs(slideProgress) - 1) * 0.01 + 1
            }
            let translate = slideProgress * modify * 420 + 'px', scale = 1 - Math.abs(slideProgress) / 6, zIndex = 999 - Math.abs(Math.round(10 * slideProgress))
            slide.transform(
              'translateX(' + translate + ') scale(' + scale + ')'
            )
            slide.css('zIndex', zIndex)
            slide.css('opacity', 1)
            if (Math.abs(slideProgress) > 3) {
              slide.css('opacity', 0)
            }
          }
        },
        setTransition: function (transition) {
          for (var i = 0; i < this.slides.length; i++) {
            var slide = this.slides.eq(i)
            slide.transition(transition)
          }
        },
      },
    })
  }

  render() {
    let { status, selectTeacher } = this.state;
    return (
      <div>
        <div className="teacher-swiper">
          <div className="swiper-container swiper-container-teacher">
            <div className="swiper-wrapper">
              {Info.map((teacherItem, teacherIndex) => (
                <div key={'teacherSwiperList-' + teacherIndex}
                  className="swiper-slide"
                  onClick={() => this.handleClickTeacher(teacherItem)}>
                  <div className="teacher-swiper-img" style={{ backgroundImage: 'url(' + teacherItem.img + ')' }}>
                  </div>
                  <div className="teacher-swiper-name">{teacherItem.name}</div>
                  <div className="teacher-swiper-content">
                    <p className='teacher-swiper-layout'>
                      <span className='p1'>{teacherItem.university}</span>
                    </p>
                    <p className='teacher-swiper-layout'>{teacherItem.experience}年</p>
                    <p className='teacher-swiper-layout'>
                      {(teacherItem.credential).map((item, index) => (
                        <span className='p2' key={'credential-' + index} > {item}</span>
                      ))}
                    </p>
                    <p className='teacher-swiper-layout'>{teacherItem.feature}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
          {/* <div class="swiper-pagination"></div> */}
          <div className="swiper-button-prev swiper-button-prev-teacher"></div>
          <div className="swiper-button-next swiper-button-next-teacher"></div>
        </div>

        {
          status && (
            <div className="teacher-popup">
              <div className="teacher-popup-layout">
                <div
                  className="teacher-popup-close"
                  onClick={this.handleClose}
                ></div>
                <div className="teacher-img" style={{ backgroundImage: 'url(' + selectTeacher.imgs + ')' }}></div>
                <div className="teacher-content">
                  <div className="teacher-name">
                    {selectTeacher.name}<img className="xing" alt="avatar" src={selectTeacher.xing} />
                  </div>
                  <div className="teacher-basic">
                    <span>中国</span>
                    <span>{selectTeacher.university}</span>
                    <span>{selectTeacher.experience}年</span>
                  </div>
                  <div className="teacher-style">
                    <span>教学风格</span>
                    <span>
                      {selectTeacher.feature}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          )
        }

      </div>
    )
  }
}

export default Teachers
